import React from "react";
import PropTypes from 'prop-types';
import DynamicAddButton from "../DynamicAddButton";
import CheckoutLink from "./CheckoutLink";

import FreeShippingIndicator from "../FreeShippingIndicator";

export default function ItemCartBox({
  application, product, cartItem, shoppingCart,
}) {
  const { regularPriceCents } = product;

  let price = regularPriceCents && new Money(regularPriceCents);

  return <div className="cart-box text-left lg:text-right">
    {price && <div className="text-2xl text-brand-primary">{price.toString()}</div> }
    <FreeShippingIndicator priceCents={regularPriceCents} />

    <DynamicAddButton
      className="text-2xl w-full bg-brand-primary text-anti-primary py-2 cursor-pointer hover:opacity-75"
      application={application}
      product={product}
      cartItem={cartItem}
    />

    {cartItem && <CheckoutLink shoppingCart={shoppingCart} />}
  </div>
}

ItemCartBox.propTypes = {
  product: PropTypes.object.isRequired,
  application: PropTypes.object,
  cartItem: PropTypes.object,
  shoppingCart: PropTypes.object // may be null if user has no cart yet
}
